'use client';
import { isConvertibleColor } from '../validators/validators.js';
import { toRGBA } from '../toRGBA/toRGBA.js';

var mix = function(a, b, ratio) {
    var _a = a * (1 - ratio);
    var _b = b * ratio;
    return parseInt(String(_a + _b), 10);
};
var blend = function(target, admixture, ratio) {
    if (ratio === void 0) ratio = 0.5;
    if (!isConvertibleColor(target)) {
        return target;
    }
    var _toRGBA = toRGBA(target), r = _toRGBA.r, g = _toRGBA.g, b = _toRGBA.b;
    var _toRGBA1 = toRGBA(admixture), _r = _toRGBA1.r, _g = _toRGBA1.g, _b = _toRGBA1.b;
    return "rgba(" + mix(r, _r, ratio) + "," + mix(g, _g, ratio) + "," + mix(b, _b, ratio) + ",1)";
};

export { blend };
